import { render, staticRenderFns } from "./ItemBundle.vue?vue&type=template&id=33adb422&scoped=true&"
import script from "./ItemBundle.vue?vue&type=script&lang=js&"
export * from "./ItemBundle.vue?vue&type=script&lang=js&"
import style0 from "./ItemBundle.vue?vue&type=style&index=0&id=33adb422&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33adb422",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCheckbox,VIcon,VImg,VRow})
